import { EActionMethod, IItemPayment } from "@/utilities/types/Payment";
import { Button } from "rizzui";


interface ApprovePaymentProps {
  closeModal: () => void;
  changeStatusPayment: (id: string, type: string) => Promise<void>;
  item: IItemPayment;
}
export default function ApprovePayment({
  closeModal,
  changeStatusPayment,
  item,
}: ApprovePaymentProps) {
  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-6">Confirm Status Change</h2>
      <p>
        Are you sure you want to change the current status? This action cannot
        be undone.
      </p>
      <div className="mt-6 flex gap-3 justify-end">
        <Button onClick={() => closeModal()}>No</Button>
        <Button
          onClick={async () => {
            closeModal();
            await changeStatusPayment(
              item.xeroInvoiceID,
              EActionMethod.APPROVED
            );
          }}
          variant="outline"
          color="danger"
        >
          Yes
        </Button>
      </div>
    </div>
  );
}